import logo from "../../assets/recode_pro-logo-1.svg";
import { useRef, useState } from "react";
// import Papa from "papaparse";
import styles from "./EnviarDocumentos.module.scss";
import { AlignCenter } from "../../components/Box/Box";
import { InputFile } from "../../components/Input/InputFile";
import { ContainedBtn } from "../../components/ButtonTypes/Button";
import { swalTheme } from "../../services/Swal";
import Swal from "sweetalert2";
import { Toast } from "../../services/Swal";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

function UsuarioUploadDoc() {
  const [codigo, setCodigo] = useState(""); //JN91K3RO50
  const [valido, setValido] = useState(false);
  const [foraDoPrazo, setForaDoPrazo] = useState(false);
  const [fileName, setFileName] = useState({});
  const fd = useRef({});
  const { idestudante } = useParams();
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const maxFileSize = 2 * 1024 * 1024; // 2MB

  const dataAtual = new Date().getTime();
  const dataFinal = new Date("2023-05-12 17:00:00").getTime()

  useEffect(() => {
    try {
      let decodedId = atob(idestudante);

      fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/GetListaDocumentosStatus/ForaDoPrazo?idEstudante=${decodedId}`, {
        method: "GET",
      })
        .then(response => response.json())
        .then(result => setForaDoPrazo(result))
        .catch(error => console.log('error', error));
    } catch (error) {
      console.error('error', error);
      window.location.replace("https://recodepro.org.br/")
    }
  }, [idestudante])

  useEffect(() => {
    try {
      let decodedId = atob(idestudante);

      fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/GetListaDocumentosStatus?idEstudante=${decodedId}`, {
        method: "GET",
        //headers: { Authorization: user.token },
      })
        .then(response => response.json())
        .then(result => {
          console.warn(result);
          setTipoDocumentos(result)
        })
        .catch(error => console.log('error', error));
    } catch (error) {
      console.error(error);
      window.location.replace("https://recodepro.org.br/")
    }
  }, [idestudante])

  async function validaCodigo(IdEstudante, codigo) {
    let decodedId = atob(IdEstudante);

    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/RecodePro/ValidaCodigo?IdEstudante=${decodedId}&Codigo=${codigo}&tipoCodigo=DOCUMENTOS`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setValido(true);
          return Toast.fire({
            icon: "success",
            title: "Código válido",
          });
        } else {
          setCodigo("");
          setValido(false);
          return Toast.fire({
            icon: "error",
            title: "Código inválido",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        setCodigo("");
        setValido(false);
        Toast.fire({
          icon: "error",
          title: "Código inválido",
        });
      });
  }

  async function resizeImageIfNeeded(imageFile) {
    if (imageFile.size <= maxFileSize) {
      return imageFile;
    } else {
      const image = new Image();
      const reader = new FileReader();
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      const resizedImageFile = await new Promise((resolve) => {
        reader.onload = function (event) {
          image.onload = function () {
            let width = image.width;
            let height = image.height;
            const maxDimension = Math.max(width, height);

            if (maxDimension > 2048) {
              const scale = 2048 / maxDimension;
              width = Math.round(width * scale);
              height = Math.round(height * scale);
            }

            canvas.width = width;
            canvas.height = height;
            context.drawImage(image, 0, 0, width, height);
            canvas.toBlob((blob) => {
              const resizedFile = new File([blob], imageFile.name, {
                type: imageFile.type,
                lastModified: Date.now(),
              });

              if (resizedFile.size <= maxFileSize) {
                resolve(resizedFile);
              } else {
                resolve(imageFile);
              }
            }, imageFile.type, 0.9);
          };
          image.src = event.target.result;
        };
        reader.readAsDataURL(imageFile);
      });

      return resizedImageFile;
    }
  }

  async function carregaDoc(e) {
    //check if pdf or image, if image resize if needed
    let file = e.target.files[0].name.split(".").pop() === "pdf" ? e.target.files[0] : await resizeImageIfNeeded(e.target.files[0]);

    //check file size
    const fileSizeInKb = (file.size / 1024).toFixed(2);
    if (file.size > maxFileSize)
      return Toast.fire({
        icon: "warning",
        title: `O arquivo ${file.name} (${fileSizeInKb} kb) é muito grande e não pode ser utilizado.`,
      });

    fd.current[e.target.name] = new FormData();
    setFileName({ ...fileName, [e.target.name]: file.name });

    if (e.target && file) {
      fd.current[e.target.name].append("IdEstudante", atob(idestudante));
      fd.current[e.target.name].append("Documento", e.target.name);
      fd.current[e.target.name].append("Arquivo", file);
    }
  }

  async function postDosDocumentos(receivedFormData) {
    await fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/UploadDocumentos`, {
      method: "POST",
      body: receivedFormData,
    })
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  }

  function RowDocumento({ tipoDocumento }) {
    tipoDocumento = tipoDocumento.toLowerCase();
    return (
      <tr className={styles.tr}>
        <td>{tipoDocumento.toUpperCase()}</td>
        <td>
          <InputFile
            className={styles.fileLabel}
            type="file"
            name={tipoDocumento}
            // accept=".pdf"
            accept="image/jpeg,image/gif,image/png,application/pdf"
            icon={<FontAwesomeIcon icon={faFileArrowUp} />}
            onChange={carregaDoc}
          />
        </td>
        <td>{fileName?.[tipoDocumento]}</td>
      </tr>
    );
  }

  if (foraDoPrazo) return (
    <section>
      <AlignCenter>
        <img src={logo} className={styles.logo} alt="logo" />
      </AlignCenter>

      <AlignCenter>
        <h1>Prazo encerrado</h1>
      </AlignCenter>

      <AlignCenter>
        <h2>Infelizmente o prazo para envio de documentos se encerrou no dia 05/05/2023, às 23:59 (Sexta-Feira)</h2>
      </AlignCenter>
    </section>
  )

  if (tipoDocumentos.length === 0) return (
    <section>
      <AlignCenter>
        <img src={logo} className={styles.logo} alt="logo" />
      </AlignCenter>

      <AlignCenter>
        <h1>Olá, parabéns pela classificação!</h1>
      </AlignCenter>

      <AlignCenter>
        <h2>Você não possui documentos para enviar.</h2>
      </AlignCenter>
    </section>
  )

  if (dataAtual >= dataFinal) return (
    <>
      <section>
        <AlignCenter>
          <img src={logo} className={styles.logo} alt="logo" />
        </AlignCenter>

        <AlignCenter>
          <h1>Envio de documentos encerrado!</h1>
        </AlignCenter>
      </section>
    </>
  );

  return (
    <>
      <section>
        <AlignCenter>
          <img src={logo} className={styles.logo} alt="logo" />
        </AlignCenter>

        <AlignCenter>
          <h1>Parabéns!</h1>
        </AlignCenter>

        <AlignCenter>
          <h1>Você está na fase de envio de documentos do processo seletivo do Recode Pro 2023!</h1>
        </AlignCenter>

        <AlignCenter>
          <h2>Nos campos abaixo, anexe cada um dos documentos em seu devido campo para validação da nossa equipe: </h2>
        </AlignCenter>

        <br />

        <ul>
          <li>· RG (frente e verso);</li>
          <li>· CPF (frente e verso);</li>
          <li>· Comprovante de Escolaridade: Certificado de Conclusão e Histórico Escolar;</li>
          <li>· Comprovante de Residência (conta de água, luz, telefone ou gás);</li>
          <li>· Comprovantes da Renda do seu grupo familiar (de todos os moradores da casa): holerite, carteira de trabalho, Declaração de Imposto de Renda, Declaração Comprobatória de Percepção de Rendimentos (DECORE), Contratos, Recibos e Notas Fiscais emitidas, etc.</li>
          <li>· Certidão de Nascimento</li>
        </ul>
        <br />

        <p>Acesse o documento a seguir no link para ver um modelo de cada documento que deverá ser encaminhado nesta plataforma Recode Pro e o passo a passo para te auxiliar no envio dos documentos.</p>
        <br />

        {/* <p><Link onClick={() => { window.location.replace("https://recodepro.org.br/") }}>link do PPT ou PDF (manual)</Link></p> */}
        <p><Link target="_blank" to="/Tutorial_para_envio_docs_candidat_RPro2023.pdf">Link do manual</Link></p>
        <br />

        <p><b>Importante:</b> Quando algum documento for invalidado pela equipe você receberá uma notificação em seu email cadastrado na inscrição com as orientações para ajuste da documentação ou complemento da informação.</p>
        <br />
      </section>

      <form
        // Adicionadas async
        onSubmit={async (e) => {
          e.preventDefault();
          if (Object.keys(fd.current).length < tipoDocumentos.length) return Toast.fire({
            icon: "error",
            title: "Você precisa enviar todos os documentos",
          })

          try {
            tipoDocumentos.forEach(async (documento) =>
              await fd.current[documento.toLocaleLowerCase()]
                ? await postDosDocumentos(fd.current[documento.toLocaleLowerCase()])
                : console.error("Not posting: ", documento)
            );
          } catch (error) {
            console.error(error);
          } finally {
            return Swal.fire({
              title: "Sucesso!",
              text: "Os seus documentos foram enviados com sucesso!",
              icon: "success",
              ...swalTheme,
            }).then(() => {
              window.location.replace("https://recodepro.org.br/");
            });
          }
        }}
      >
        <section className={styles.inputSmallerWidth}>
          <input
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            required
            className={styles.input}
            placeholder="Código de acesso"
            type="text"
            onBlur={(e) => validaCodigo(idestudante, e.target.value)}
          />
          <br />
        </section>

        <div className={styles.containerTable}>
          <table className={styles.table}>
            <tbody className={styles.tbody}>
              <tr>
                <th>Documento</th>
                <th>Enviar arquivo PDF</th>
                <th>Nome do arquivo</th>
              </tr>

              {tipoDocumentos.map((documento) => (
                <RowDocumento key={documento} tipoDocumento={documento} />
              ))}
            </tbody>
          </table>
        </div>
        <ContainedBtn disabled={!valido} className={styles.button}> Enviar </ContainedBtn>
      </form>
      {/* <button onClick={() => { console.log(fd.current) }}>teste</button> */}
    </>
  );
}

export default UsuarioUploadDoc;
